export enum ProductFrequencyEnum {
    daily = 'DAILY',
    semiweekly = 'SEMIWEEKLY',
    weekly = 'WEEKLY',
    semimonthly = 'SEMIMONTHLY',
    monthly = 'MONTHLY',
    bimonthly = 'BIMONTHLY',
    quarterly = 'QUARTERLY',
    semiannually = 'SEMIANNUALLY',
    annually = 'ANNUALLY'
}

export const productFrequencyMap = new Map<string, number>([
    [ProductFrequencyEnum.daily, 1],
    [ProductFrequencyEnum.semiweekly, 3],
    [ProductFrequencyEnum.weekly, 7],
    [ProductFrequencyEnum.semimonthly, 15],
    [ProductFrequencyEnum.monthly, 30],
    [ProductFrequencyEnum.bimonthly, 60],
    [ProductFrequencyEnum.quarterly, 90],
    [ProductFrequencyEnum.semiannually, 180],
    [ProductFrequencyEnum.annually, 365]
]);
